import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import { EAuthLoginVM } from './EAuthLoginVM';
import { useHistory } from 'react-router-dom';
import { Form, FormGroup, Label, Input, Row, Col } from 'reactstrap';
import { SecondaryButton } from 'nrcs-design-system';
import { mdiExitToApp, mdiAlertOutline } from '@mdi/js';
import Icon from '@mdi/react';
import './EAuthLogin.scss';

const EAuthLoginComponent = (props) => {
  const history = useHistory();

  const vm = useRef(new EAuthLoginVM(props, history)).current;

  useEffect(() => {
    vm.redirectToLogin();
  }, []);

  return (
    <main className="login-page" role="main">
      <Row>
        <Col className="col-xs-10  side-bar">
          <div></div>
        </Col>
        <Col className="col-xs-10 login-container">
          <h1>
            Welcome to <br /> <b>NRCS Engineering Tool Suite</b>
          </h1>
          <div className="login-form">
            <h2 className="mt-4 mb-4">
              <b>Redirecting to eAuth sign in. Please Wait...</b>
            </h2>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export const EAuthLogin = observer(EAuthLoginComponent);
